import React from "react";
import { Link, matchPath } from "react-router-dom";

import { useAuthDataContext } from "modules/auth";
import routes, { DefinedRoute } from "routes";

const findMatchingPath = (definedRoutes: DefinedRoute[], to: string) => {
  for (const definedRoute of definedRoutes) {
    const match = matchPath(to, {
      path: definedRoute.path,
      exact: true,
      strict: false,
    });
    if (match) return { match, definedRoute };
  }
  return { match: undefined, definedRoute: undefined };
};

export const QuickLink = ({
  className,
  to,
  children,
}: {
  children: React.ReactNode;
  className?: string;
  to: string;
}) => {
  const { enforcer } = useAuthDataContext();
  const { match, definedRoute } = findMatchingPath(routes, to);
  if (!match || !definedRoute)
    throw new Error(`Unable to match route for path ${to}`);
  if (!enforcer.can(definedRoute.requiredPermission, match.params)) return null;
  return (
    <Link
      to={to}
      className={`inline-block whitespace-no-wrap hover:bg-gray-400 bg-gray-100 rounded-full px-3 py-1 text-sm font-semibold mr-2${
        className ? " " + className : ""
      }`}
    >
      {children}
    </Link>
  );
};
